import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-240739 remove as part of Universal Scheduler Cleanup
export const getHasUniversalSchedulerEnabled = createHasFeatureSelector(
  FeatureNames.UniversalScheduler,
);
